import {
  SubmitFeedbackRequest,
  SubmitFeedbackResponse,
} from '@activepieces/shared';
import { api } from '@/lib/api';

export const feedbackApi = {
  submit(request: SubmitFeedbackRequest): Promise<SubmitFeedbackResponse> {
    return api.post<SubmitFeedbackResponse>('/v1/feedback', request);
  },
};
